/**
 * Extrae un mensaje legible del cuerpo de error de la API (Laravel u otros formatos).
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const err = error as Record<string, any>;
  const data = err?.response?.data;

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error;
  }

  if (data?.error && typeof data.error === 'object' && typeof (data.error as any).message === 'string') {
    return String((data.error as any).message);
  }

  if (data?.errors && typeof data.errors === 'object') {
    for (const value of Object.values(data.errors)) {
      if (Array.isArray(value) && value[0] != null) {
        return String(value[0]);
      }
      if (typeof value === 'string' && value.trim()) {
        return value;
      }
    }
  }

  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message;
  }

  return fallback;
}
